import {
  TiptapBase,
  Heading,
  BulletList,
  OrderedList,
  Bold,
  Italic,
  Strike,
  History,
  FontFamily,
  Link,
  Underline,
  TextAlign,
  HardBreak,
  ListItem,
  TextStyle,
  AutoHideToolbar,
  AutoSaveTasks,
  Placeholder,
} from '@/js/util/tiptap/extensions';

import {
  FontFamilyHandlers,
  HeadingLevelHandlers,
  HistoryHandlers,
  LinksHandlers,
  ListsHandlers,
  TextAlignmentHandlers,
  TextFormattingHandlers,
} from '@/js/util/tiptap/handlers';

const placeholder = 'Leave a note about this task...';

export default class DesignerNotesConfig {
  get extensions() {
    const TaskNotesPlaceholder = Placeholder[0].configure({ placeholder });

    return [
      ...TiptapBase,
      ...Heading,
      ...BulletList,
      ...OrderedList,
      ...Bold,
      ...Italic,
      ...Strike,
      ...History,
      ...FontFamily,
      ...Link,
      ...Underline,
      ...TextAlign,
      ...HardBreak,
      ...ListItem,
      ...TextStyle,
      ...AutoHideToolbar,
      ...AutoSaveTasks,
      ...[TaskNotesPlaceholder],
    ];
  }

  get handlers() {
    return {
      ...FontFamilyHandlers,
      ...HeadingLevelHandlers,
      ...HistoryHandlers,
      ...LinksHandlers,
      ...ListsHandlers,
      ...TextAlignmentHandlers,
      ...TextFormattingHandlers,
    };
  }
}
